(function () {
    'use strict';

    angular.module('app').controller('ExternalFormsController', ExternalFormsController);

    ExternalFormsController.$inject = [
        '$scope',
        '$rootScope',
        '$window',
        '$route',
        '$routeParams',
        '$location',
        '$timeout',
        '$filter',
        '$translate',
        'blockUI',
        '$uibModal',
        'SelectService',
        'NotifyService',
        'ExternalFormService'
    ];

    function ExternalFormsController(
        $scope,
        $rootScope,
        $window,
        $route,
        $routeParams,
        $location,
        $timeout,
        $filter,
        $translate,
        blockUI,
        $uibModal,
        SelectService,
        NotifyService,
        ExternalFormService
    ) {
        $scope.getFiltersList = SelectService.getLPList;
        $scope.getExternalForms = getExternalForms;
        $scope.getPages = getTotalPaginatedPages;

        $scope.params = {
            page: 1,
            count: 10,
            date_from: moment().subtract(1, "month").utc().toDate(),
            date_to: moment().endOf("day").utc().toDate(),
            time_from: moment().startOf('day').utc().toDate(),
            time_to: moment().endOf('day').utc().toDate(),
            signed: true,
            form_type: null,
            title: null,
        };

        $scope.form_types = [
            {id: 'tax', title: 'Tax'}
        ]

        $scope.userIdTypes = [
            {id: "phone", title: "Customer number"},
            {id: "email", title: "Email"},
            {id: "id", title: "Id"},
            {id: "external-id", title: "External id"},
        ];

        $scope.data = {
            externalFormsList: null,
            total_count: null
        }

        $scope.table_cols = [
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'title', text: 'Title', visible: true},
                    {value: 'external_form_id', text: 'External form id', visible: true},
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'user_name', text: 'Name', visible: true},
                    {value: 'user_phone', text: 'Customer number', visible: true},
                    {value: 'user_email', text: 'Email', visible: true},
                    {value: 'user_external_id', text: 'External id', visible: true},
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'type', text: 'Type', visible: true},
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'signed', text: 'Signed', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'created', text: 'Created', visible: true}
                ]
            },
        ]

        $scope.pager_count = [10, 20, 50, 100, 200];
        var block_external_forms_list = blockUI.instances.get("external-forms-table");

        initController();

        function initController() {
            function s() {
                if ($scope.data.currentFilter) {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (
                            filterItem
                        ) {
                            if (filterItem.id === $routeParams.loyalty_id) {
                                return true;
                            }
                        }
                    );
                    $scope.params.user_id_value = $routeParams.user_id;
                    $scope.params.user_id_type = 'id';
                    getExternalForms();
                } else {
                    $timeout(s, 250);
                }
            }

            $scope.params.user_id_type = 'email';
            if ($routeParams && $routeParams.loyalty_id && $routeParams.user_id) {
                s();
            }
        }


        function getExternalForms() {
            block_external_forms_list.start();
            $scope.data.externalFormsList = null;

            var params = angular.copy($scope.params);

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get("hour"),
                minute: moment(params.time_from).get("minute"),
                second: moment(params.time_from).get("second"),
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get("hour"),
                minute: moment(params.time_to).get("minute"),
                second: moment(params.time_to).get("second"),
            });
            delete params.time_to;

            params = dateFieldsFormat(params, null, "YYYY-MM-DD[T]HH:mm:ss[Z]", true);
            params = cleanRequestData(params);

            params.loyalty_id = $scope.data.currentFilter.id;

            ExternalFormService.All(params, function (success, response) {
                if (!success) {
                    block_external_forms_list.stop();
                    NotifyService.Error(response.message)
                    return;
                }

                $scope.data.externalFormsList = response.data;
                $scope.data.total_count = response.summary.total_rows_count;
                $timeout(function () {
                    block_external_forms_list.stop();
                }, 1000);
            })
        }

        $scope.declineUserExternalForm = function (form_id) {
            ExternalFormService.Delete(form_id, function (success, data) {
                if (success) {
                    NotifyService.Success('Success', true);
                    getExternalForms();
                } else {
                    NotifyService.Error('Error', true);
                }
            })
        }

        $scope.pageChange = function () {
            getExternalForms();
        };

        $scope.onCountChange = function (count) {
            $scope.params.page = 1;
            $scope.params.count = count;
            getExternalForms();
        };

        $scope.downloadPDF = function (form_id) {
            block_external_forms_list.start();
            ExternalFormService.Get(form_id, function (success, data) {

                if (!success) {
                    block_external_forms_list.stop();
                    return
                }

                var post_data = {
                    pdf_url: data.file,
                    data: data.user_data
                }
                if (data.signed) {
                    post_data.signature = data.signature
                }
                ExternalFormService.getDocument(post_data, function (successPdf, result) {
                    if (!successPdf) {
                        block_external_forms_list.stop();
                        NotifyService.Error('Can not print the external form', true);
                        return;
                    }
                    var binary = atob(result.data.replace('data:application/pdf;base64,', ''));
                    var len = binary.length;
                    var buffer = new ArrayBuffer(len);
                    var view = new Uint8Array(buffer);
                    for (var i = 0; i < len; i++) {
                        view[i] = binary.charCodeAt(i);
                    }
                    var blob = new Blob([view], {type: "application/pdf"});
                    saveAs(blob, `${data.title}-${data.created}.pdf`);
                    block_external_forms_list.stop();
                })
            })
        }

        $rootScope.$watch("LP_LIST", function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = angular.copy($rootScope.LP_LIST);
                if (
                    $rootScope.ENV.filters.global_filter &&
                    $rootScope.ENV.filters.global_filter.loyalty_id !== "0"
                ) {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (
                        filterItem
                    ) {
                        if (filterItem.filter_list_type === "loyalty") {
                            if (
                                filterItem.id ===
                                $rootScope.ENV.filters.global_filter.loyalty_id
                            ) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === "pos") {
                            if (
                                filterItem.loyalty_id ===
                                $rootScope.ENV.filters.global_filter.loyalty_id
                            ) {
                                return true;
                            }
                        }
                    });
                } else {
                    $scope.data.currentFilter = getFirstActive($scope.data.filtersList);
                }
            }
        });

        $scope.$watch(
            "data.currentFilter",
            function (newValue, oldValue) {
                if (newValue) {
                    var l = $rootScope.ENV.filters.orders_list;
                    if (l) l.filter = newValue;
                    else l = {filter: newValue};

                    $rootScope.ENV.filters.orders_list = l;

                    if (l.filter.filter_list_type === "loyalty") {
                        $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.id};
                    } else if (l.filter.filter_list_type === "pos") {
                        $rootScope.ENV.filters.global_filter = {
                            loyalty_id: l.filter.loyalty_id,
                        };
                    }

                    $rootScope.storeENV();
                }
            },
            true
        );

        $scope.$watch("params.taxes.date_from", function (newValue, oldValue) {
            if (
                !!newValue &&
                moment($scope.params.date_to).diff(newValue, "months", true) >
                dateDiff
            )
                $scope.params.date_to = moment($scope.params.date_from)
                    .add(dateDiff, "month")
                    .utc()
                    .toDate();
        });

        $scope.$watch("params.taxes.date_to", function (newValue, oldValue) {
            if (
                !!newValue &&
                moment(newValue).diff($scope.params.date_from, "months", true) >
                dateDiff
            )
                $scope.params.date_from = moment($scope.params.date_to)
                    .subtract(dateDiff, "month")
                    .utc()
                    .toDate();
        });

    }


})();
